import {formatTime, getRemainingTime} from '../utils/gatingHelper';
import {getLocalStorage} from '../utils/Utils';

export const createGatingTimer = (
  videoPlayer: any,
  assetId: string,
  limitSeconds: number,
  onSubscribe: () => void
) => {
  if (document.querySelector('.freeMinutesInfoContainerLiveTv')) return;

  const freeMinutesInfoContainer = document.createElement('div');
  freeMinutesInfoContainer.className = 'freeMinutesInfoContainerLiveTv';

  const gatingTimerWrapper = document.createElement('div');
  gatingTimerWrapper.className = 'gatingTimerWrapper';

  const freeMinutesInfoText = document.createElement('div');
  freeMinutesInfoText.className = 'freeMinutesInfoText';
  freeMinutesInfoText.innerHTML = 'Free watch ends in ';

  const freeMinutesTimer = document.createElement('span');
  freeMinutesTimer.className = 'freeMinutesTimer';
  freeMinutesTimer.id = 'freeMinutesTimer';

  const remainingTime = getRemainingTime(assetId, limitSeconds);
  freeMinutesTimer.innerHTML = formatTime(remainingTime);

  freeMinutesInfoText.appendChild(freeMinutesTimer);
  gatingTimerWrapper.appendChild(freeMinutesInfoText);

  const userType = getLocalStorage('userType') || 'guest';
  const buyCtaText = userType === 'premium' ? 'Upgrade' : 'Buy Premium';

  // Add "Buy Plan" button (using user's buyPlanBtn class and icon span)
  const buyPlanBtn = document.createElement('div');
  buyPlanBtn.className = 'buyPlanBtn';
  buyPlanBtn.innerHTML = `<span class="icon-crown"></span> ${buyCtaText}`;
  buyPlanBtn.onclick = (e) => {
    e.stopPropagation();
    onSubscribe();
  };
  gatingTimerWrapper.appendChild(buyPlanBtn);

  freeMinutesInfoContainer.appendChild(gatingTimerWrapper);

  const videoEL = videoPlayer && videoPlayer.el();
  if (videoEL) {
    videoEL.appendChild(freeMinutesInfoContainer);
  }
};

export const updateGatingTimerUI = (assetId: string, limitSeconds: number) => {
  const timerElement = document.getElementById('freeMinutesTimer');
  if (timerElement) {
    const remainingTime = getRemainingTime(assetId, limitSeconds);
    timerElement.innerHTML = formatTime(remainingTime);
  }
};

export const removeGatingTimer = () => {
  const container = document.querySelector('.freeMinutesInfoContainerLiveTv');
  if (container && container.parentNode) {
    container.parentNode.removeChild(container);
  }
};

export const showGatingPopup = (videoPlayer: any, onSubscribe: () => void) => {
  if (document.querySelector('.freeMinutesEndedPopup')) return;

  videoPlayer.pause();

  const popupOverlay = document.createElement('div');
  popupOverlay.className = 'freeMinutesEndedPopup';

  const popupContent = document.createElement('div');
  popupContent.className = 'popupContent';

  const title = document.createElement('h2');
  title.innerHTML = 'Your free watch has ended';

  const message = document.createElement('p');
  message.innerHTML = 'Buy Premium to continue watching.';

  const subscribeBtn = document.createElement('button');
  subscribeBtn.className = 'subscribeBtn';

  const userType = getLocalStorage('userType') || 'guest';
  const buyCtaText = userType === 'premium' ? 'Upgrade' : 'Buy Premium';

  // User added icon-crown in span for the popup button too in their SCSS
  subscribeBtn.innerHTML = `<span class="icon-crown"></span> ${buyCtaText}`;
  subscribeBtn.onclick = onSubscribe;

  popupContent.appendChild(title);
  popupContent.appendChild(message);
  popupContent.appendChild(subscribeBtn);
  popupOverlay.appendChild(popupContent);

  const videoEL = videoPlayer && videoPlayer.el();
  if (videoEL) {
    videoEL.appendChild(popupOverlay);
  }
};
